module.exports = __webpack_public_path__ + "img/restaurant_2_cafe.1059d8d2.jpg";